import React, { useCallback, useState } from 'react';
import { Platform, View } from 'react-native';
import Text, { styles } from 'design-system/Text';
import useStyles from 'hooks/useStyles';
import useColors from 'hooks/useColors';
import createStyleSheets from 'utils/createStyleSheets';
import { MoneyTextInput } from 'utils/packages/moneyInput';
import { isWeb } from '../../../../constants';
import ItemBadgeWrapper from './ItemBadgeWrapper';
import IconAmountLower from './icons/toolbar/IconAmountLower';
const AmountLowerItemBadge = ({ filter, scrollY, onPress, cancelEdit, handleClose, scrollToItem, amountLowerValue, isActiveKeyboard, refAmountLowerInput, onChangeAmountLower, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const [inputWidth, setInputWidth] = useState(5);
    const onChange = useCallback((text) => {
        onChangeAmountLower?.(text);
        if (isWeb && text) {
            setInputWidth(5 + text.length * 8);
        }
    }, [onChangeAmountLower]);
    return (<ItemBadgeWrapper scrollY={scrollY} handlePress={onPress} onCancel={handleClose} scrollToItem={scrollToItem} isActiveKeyboard={isActiveKeyboard}>
      <IconAmountLower gradientKey="lightPink" width={16} height={16}/>
      <View style={styles.container}>
        <Text Text-14>{filter.badgeText}</Text>
        <View pointerEvents="none">
          <MoneyTextInput autoFocus maximumFractionalDigits={0} maximumIntegerDigits={9} onFocus={cancelEdit} pointerEvents="none" ref={refAmountLowerInput} value={amountLowerValue.replace(/,/g, '')} onChangeText={onChange} style={[styles.badgeInputText, isWeb && { width: inputWidth }]} selectionColor={colors.text.selection}/>
        </View>
      </View>
    </ItemBadgeWrapper>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    badgeInputText: {
        padding: 0,
        ...styles.Numbers_14,
        lineHeight: undefined,
        color: colors.text.primary,
        ...Platform.select({
            web: {
                outlineStyle: 'none',
                caretColor: colors.text.selection,
            },
        }),
    },
}));
export default AmountLowerItemBadge;
